import Card from './categoryCard';
import { useHeader } from '@/components/context/HeaderContext';
import { useEffect, useState } from 'react';
import { useGetContentCategoriesQuery } from '@/store/api/categoryApi';
import FullScreenLoader from '@/components/common/FullScreenLoader';

export default function UnlockedContent() {
  const { setHeader } = useHeader();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading, isError } = useGetContentCategoriesQuery(false);

  useEffect(() => {
    setHeader({
      type: 'category',
      props: {
        title: 'Open Content',
        // lastUpdated: '14-April-2026, 3:00PM',
        actionLabel: 'Create New Category',
        onActionClick: () => setIsModalOpen(true),
        // onMoreClick: () => console.log('More clicked'),
      },
    });

    return () => setHeader(null);
  }, [setHeader]);

  if (isLoading)
    return (
      <div className="p-6">
        <FullScreenLoader />
      </div>
    );
  if (isError) return <div className="p-6">Failed to load</div>;

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {data?.map((item) => (
          <Card key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
}
